import React, { Component } from "react";
import Select from "react-select";
import AsyncSelect from "react-select/lib/Async";
import { CSSTransition } from "react-transition-group";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { DateRangePicker } from "react-dates";

import moment from "moment";
import _ from "i18n";
import SearchBox from "./SearchBox";
import PageSize from "./PageSize";
import { FilterIcon } from "../Icons";
import styles from "./TTPFilterHorizontalBar.local.scss";
import "moment/locale/fr";
import "moment/locale/nl";

export default class TTPFilterHorizontalBar extends Component {
  constructor(props) {
    super(props);
    this.state = { filterFormIsVisible: false };
  }

  handleToggleFilterForm() {
    const { filterFormIsVisible } = this.props;
    const isVisible = !this.state.filterFormIsVisible;
    this.setState({ filterFormIsVisible: isVisible });
    if (filterFormIsVisible) {
      filterFormIsVisible(isVisible);
    }
  }

  // handleResetFilter = () => {
  //   this.props.handleResetFilter();
  // };

  handleSearchInputChange = word => {
    this.props.handleSearchInputChange(word);
  };

  onInputChange = (inputValue, action, isSimple = false) => {
    let selected = null;
    if (isSimple) {
      selected = inputValue ? inputValue.value + "" : null;
    } else {
      selected = inputValue.map(({ value }) => value);
    }
    action(selected);
  };

  renderFilters = () => {
    let { filters } = this.props;
    let filterCols = [];

    if (filters && filters.length > 0) {
      filters.forEach((filter, index) => {
        filterCols.push(
          <div
            style={{ width: 300 }}
            key={`col-${index}`}
            className={`small-${filter.grid}`}
          >
            {this.renderFilterByType(filter.type, filter.options)}
          </div>
        );
      });
    }

    return (
      <div className="columns">
        <div className="row">{filterCols}</div>
      </div>
    );
  };

  renderFilterByType = (type, options) => {
    switch (type) {
      case "SELECT": {
        // TODO refactor to Config constante
        return this.renderSimpleSelect(options);
      }
      case "ASYNC_SELECT": {
        return this.renderAsyncSelect(options);
      }
      case "RANGE_DATE_PICKER": {
        return this.renderRangeDatePicker(options);
      }
      default:
        return <div />;
    }
  };

  renderSimpleSelect = options => {
    return (
      <div key={options.placeholder} className={`columns`}>
        <label key={options.placeholder}>
          <span className="lbl">{_(options.placeholder)}</span>
          <Select
            isMulti={options.isMulti !== undefined ? options.isMulti : false}
            isSearchable={false}
            isClearable={
              options.isClearable !== undefined ? options.isClearable : false
            }
            isDisabled={
              options.isDisabled !== undefined ? options.isDisabled : false
            }
            closeMenuOnSelect
            placeholder={options.placeholder}
            options={options.options}
            value={filterValues(options.options, options.values)}
            onChange={inputValue =>
              this.onInputChange(inputValue, options.action, options.isSimple)
            }
            className={`ttp-select uppercase ${
              options.values && options.values.length > 0
                ? "filled-box"
                : "empty-box"
            }`}
            classNamePrefix="ttp-select"
            formatGroupLabel={formatGroupLabel}
            styles={options[0] && options[0].color && colourStyles}
          />
        </label>
      </div>
    );
  };

  renderAsyncSelect = options => {
    return (
      <div key={options.placeholder} className="columns">
        <label>
          <span className="lbl">{_(options.placeholder)}</span>
          <AsyncSelect
            value={options.value}
            key={options.key}
            isMulti={true}
            cacheOptions={true}
            closeMenuOnSelect={false}
            placeholder={_(options.placeholder)}
            onChange={options.handleChange}
            classNamePrefix="ttp-select"
            styles={colourStyles}
            defaultOptions
            loadOptions={options.loadSuggestions}
            className={`ttp-select ${
              options.values && options.values.length > 0 ? "" : "empty-box"
            }`}
          />
        </label>
      </div>
    );
  };

  renderRangeDatePicker = options => {
    let { language } = this.props;

    moment.locale(language);
    return (
      <div key={options.placeholder} className="columns">
        <label
          className={
            !options.dateRange.startDate && !options.dateRange.endDate
              ? "empty-date-picker"
              : "filled-date-picker"
          }
        >
          <span className="lbl">{_("dateRange")}</span>
          <DateRangePicker
            isOutsideRange={day =>
              day.isBefore(options.creationDate) || day.isAfter(moment())
            }
            displayFormat={() => "DD/MM/YYYY"}
            startDate={options.dateRange.startDate}
            startDateId="your_unique_start_date_id"
            endDate={options.dateRange.endDate}
            endDateId="your_unique_end_date_id"
            onDatesChange={options.action}
            focusedInput={this.state.focusedInput}
            onFocusChange={focusedInput => this.setState({ focusedInput })}
            numberOfMonths={1}
            hideKeyboardShortcutsPanel
            showClearDates={false}
            startDatePlaceholderText={_("startDate")}
            endDatePlaceholderText={_("endDate")}
          />
        </label>
      </div>
    );
  };

  render() {
    const { filterFormIsVisible } = this.state;
    let {
      customAddOn,
      cssClass,
      pageSize,
      button,
      handleListPageSizeChange,
      searchPlaceholder,
      nbResult,
      label,
      activatedFilter,
      marginLeft,
      searchInputValue,
      fetching,
      handleSearchInputChange
    } = this.props;

    return (
      <div
        id="ttp-horizontal-filter"
        className={`${filterFormIsVisible &&
          "ttp-horizontal-filter__open"} ${cssClass}`}
      >
        <div className="filter-wrapper">
          <div className="filter-wrapper">
            {customAddOn}
            {label && (
              <span
                className={styles.count_item}
                style={{
                  marginLeft: marginLeft
                }}
              >
                {label} : <p>{nbResult}</p>
              </span>
            )}
            {activatedFilter &&
              activatedFilter.length > 0 &&
              activatedFilter.map((filter, index) => (
                <span
                  className={styles.count_item}
                  style={{
                    marginLeft: marginLeft
                  }}
                >
                  {filter.label} : <p>{_(filter.value)}</p>
                </span>
              ))}
          </div>
          <div className="filter-wrapper">
            {handleSearchInputChange && (
              <SearchBox
                placeholder={searchPlaceholder}
                onChange={this.handleSearchInputChange}
                // nbResult={nbResult}
                searchInputValue={searchInputValue}
                fetching={fetching}
              />
            )}
            {pageSize && (
              <PageSize
                pageSize={pageSize}
                onChange={handleListPageSizeChange}
              />
            )}
            {button && (
              <button
                className="filter-button m-l-s"
                onClick={this.handleToggleFilterForm.bind(this)}
              >
                {_("filter")}
                <FilterIcon className="filter-icon" />
              </button>
            )}
          </div>
        </div>
        <CSSTransition
          in={filterFormIsVisible}
          timeout={200}
          classNames="filter-form"
          unmountOnExit
        >
          <div className="row filter-form">
            {this.renderFilters()}
            <div
              className="filter-close"
              onClick={this.handleToggleFilterForm.bind(this)}
            >
              <img
                className="icomoon icon-tt-close"
                src="/img/icons/close.svg"
                alt={""}
              />
            </div>
          </div>
        </CSSTransition>
      </div>
    );
  }
}

export const filterValues = (options, values) => {
  if (options && options.length > 0 && options[0].options) {
    options = options.reduce((acc, o) => {
      return acc.concat(o.options);
    }, []);
  }
  let result = options.filter(({ value }) => {
    return (
      values &&
      (Array.isArray(values) ? values.includes(value) : value === values)
    );
  });
  return result;
};

export const colourStyles = {
  control: styles => ({ ...styles, backgroundColor: "white" }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    const color = data.color;
    return {
      ...styles,
      backgroundColor: isDisabled
        ? null
        : isSelected
          ? data.color
          : isFocused
            ? color + "22"
            : null,
      color: isDisabled
        ? "#ccc"
        : isSelected
          ? true
            ? "white"
            : "black"
          : data.color,
      cursor: isDisabled ? "not-allowed" : "default"
    };
  },
  multiValue: (styles, { data }) => {
    const color = data.color;
    return {
      ...styles,
      backgroundColor: color + "22"
    };
  },
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    color: data.color
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    color: data.color,
    ":hover": {
      backgroundColor: data.color,
      color: "white"
    }
  })
};

const groupStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between"
};
const groupBadgeStyles = {
  backgroundColor: "#EBECF0",
  borderRadius: "2em",
  color: "#172B4D",
  display: "inline-block",
  fontSize: 12,
  fontWeight: "normal",
  lineHeight: "1",
  minWidth: 1,
  padding: "0.16666666666667em 0.5em",
  textAlign: "center"
};

const formatGroupLabel = data => (
  <div style={groupStyles}>
    <span>{data.label}</span>
    <span style={groupBadgeStyles}>{data.options.length}</span>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Common/filters/TTPFilterHorizontalBar.js